import { Injectable } from '@angular/core'
import { createStore, withProps } from '@ngneat/elf'
import { catchError, firstValueFrom, map, Observable, of, retry, shareReplay } from 'rxjs'
import { CommonSettings } from '../../generated/efp-api'
import { CommonSettingsHttpDao } from '../services/dao/http/common-settings.http-dao'

const commonSettingsStore = createStore(
  { name: 'commonSettings' },
  withProps<CommonSettings>({ resourceUrl: '' })
)

@Injectable({
  providedIn: 'root',
})
export class CommonSettingsRepository {
  constructor(private readonly commonSettingsService: CommonSettingsHttpDao) {}

  public resourceUrl$ = this.getResourceUrl$()

  private getResourceUrl$(): Observable<string> {
    const existing = commonSettingsStore.query((state) => state.resourceUrl)
    if (existing) {
      return of(existing)
    }

    return this.commonSettingsService.getCommmonSettings().pipe(
      retry({ count: 3, delay: 2000 }),
      map((data: CommonSettings) => {
        commonSettingsStore.update((state) => ({
          ...state,
          ...data, // update all props if needed
        }))
        return data.resourceUrl
      }),
      catchError((error) => {
        console.error('Failed to fetch resourceUrl:', error)
        return of('')
      }),
      shareReplay(1)
    )
  }

  get resourceString(): string | null {
    const resourceUrl = commonSettingsStore.query((state) => state.resourceUrl)
    return resourceUrl || null
  }

  public async getResourceUrl(): Promise<string> {
    return (
      this.resourceString ??
      (await firstValueFrom(this.commonSettingsService.getCommmonSettings()).then((data) => {
        return data.resourceUrl
      }))
    )
  }
}
